document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(e) {
        const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
        if (quickViewBtn) {
            setTimeout(() => {
                document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
            }, 2000);
        }

        const label = e.target.closest('.variant-option__label');
        if (label) {
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form], [bss-b2b-product-form='quickview']");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 1000);
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const inputSearchSelector = `input[type='search']`;
    let debounceTimer;
    document.addEventListener("input", (e) => {
        if (e.target && e.target.matches(inputSearchSelector)) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                window.dispatchEvent(new Event('scroll'));
            }, 300);
        }
    });
}); 

const target = document.querySelector('.color-drawer.drawer');

if (target) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "open"
      ) {
        if (target.hasAttribute("open")) {
            window.dispatchEvent(new Event('scroll'));
            BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
            BSS_B2B.nt.initFunction();
            document.dispatchEvent(new Event("DOMContentLoaded"));
        }
      }
    });
  });

  observer.observe(target, {
    attributes: true,
    attributeFilter: ["open"],
  });
}

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".cart__nt-button");
  if (btn) {
    const closeBtn = document.querySelector(".color-drawer.drawer .cart-drawer__header-content-left");
    if (closeBtn) {
      closeBtn.click(); 
    }
  }
});
